<template>
    <Doughnut v-if="type" :id="id" :options="chartOptions" :data="chartData" :style="chartStyles" />
    <Bar v-else :id="id" :options="chartOptions" :data="chartData" :style="chartStyles" />
</template>

<script>
import { Bar, Doughnut } from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    PointElement,
    LineElement,
    CategoryScale,
    LinearScale,
    ArcElement
} from 'chart.js/auto';

ChartJS.register(Title, Tooltip, Legend, BarElement, PointElement, LineElement, CategoryScale, LinearScale, ArcElement);

export default {
    name: 'BarChart',
    components: { Bar, Doughnut },
    props: {
        id: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: ''
        },
        chartData: {
            type: Object,
            required: true
        },
        chartOptions: {
            type: Object,
            default: () => {}
        },
        chartStyles: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
